// src/components/usecases/Defi_Posting.js
import React from 'react';
import './defi_posting.css';

import defi1 from '../../assets/defi1.png';
import defi2 from '../../assets/defi2.png';
import defi3 from '../../assets/defi3.png';
import defi4 from '../../assets/defi4.png';

export default function Defi_Posting() {
  const flowImages = [defi1, defi2, defi3, defi4];
  return (
    <div className="defi-page">
      <div className="content-wrapper">
        <h1 className="main-title">
          Seamless Command Recognition and Real-Time On-Chain Data Access for Next-Generation DeFi Interfaces
        </h1>
        <h2 className="sub-title">
          Leveraging Natural Language Processing and Blockchain Data Streaming to Deliver Instant, Context-Aware Financial Insights and Actions
        </h2>

        <p className="intro-text">
          In the rapidly evolving world of decentralized finance (DeFi), user experience plays a critical role in adoption. As the DeFi ecosystem grows more complex, it becomes essential to provide intuitive and intelligent interfaces that can bridge the gap between human language and blockchain functionality. To address this challenge, we introduce a dual-feature system designed to dramatically enhance user interactions with DeFi protocols through <strong>natural language command parsing</strong> and <strong>real-time on-chain data retrieval</strong>.
        </p>

        {/* UI/UX Flow Images */}
        <div className="flow-wrapper">
          <div className="flow-container">
            {flowImages.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`DeFi flow ${idx + 1}`}
                className="flow-image"
              />
            ))}
          </div>
        </div>

        <section className="section">
          <h3>1️⃣ Natural Language-Based Command Interpretation (NLP Intent Parsing)</h3>
          <div className="subsection">
            <h4>Objective</h4>
            <p>Enable seamless user interactions by interpreting commands spoken or typed in natural language—and mapping them to on-chain functions.</p>
          </div>

          <div className="subsection">
            <h4>Key Capabilities</h4>
            <ul>
              <li><strong>Automatic Command Recognition:</strong> Parse phrases such as “swap ETH to USDC” or multilingual inputs (“스왑해줘”) to actionable intents.</li>
              <li><strong>Advanced Extraction:</strong> Identify tokens, amounts, and requested actions through NLP models.</li>
              <li><strong>Function Mapping:</strong> Route parsed intent to DeFi modules (swap, staking, APR comparison) for execution in real time.</li>
            </ul>
          </div>
        </section>

        <section className="section">
          <h3>2️⃣ Real-Time On-Chain Data Querying</h3>
          <div className="subsection">
            <h4>Objective</h4>
            <p>Empower users with immediate access to the latest DeFi metrics by querying blockchain networks as requested.</p>
          </div>

          <div className="subsection">
            <h4>Key Capabilities</h4>
            <ul>
              <li><strong>Multi-Protocol Integration:</strong> Use The Graph, Substreams, and JSON-RPC for cross-chain data retrieval.</li>
              <li><strong>Dynamic Metrics:</strong> Fetch live APYs, liquidity pools, token balances, and prices.</li>
              <li><strong>Instant API Responses:</strong> Provide data for interactive dashboards or conversational bots without delay.</li>
            </ul>
          </div>
        </section>

        <section className="section conclusion">
          <h3>Conclusion</h3>
          <p>
            By combining natural language intent parsing and live on-chain queries, this system lowers barriers to DeFi adoption—delivering an intelligent, human-centric interface for both novices and experts.
          </p>
        </section>
      </div>
    </div>
  );
}